import { TranscriptSpeaker } from 'src/models/Transcript'
import { isChromakeyModeActive, ViewMode } from 'src/utils/env'

import { UNIDENTIFIED_SPEAKER_ID } from './constants'

export type GetAuthorNameParams = {
    author: TranscriptSpeaker | undefined
    shouldSuppressSpeakerName: boolean | undefined
    isDiarizationSupported: boolean
    viewMode: ViewMode | null
}

export const getAuthorName = ({ author, shouldSuppressSpeakerName, isDiarizationSupported, viewMode }: GetAuthorNameParams) => {
    if (shouldSuppressSpeakerName) {
        return ''
    }

    if (viewMode === 'document' && !author?.name) {
        return '>>'
    }

    if (isChromakeyModeActive || !isDiarizationSupported || (!!author && !author.name && author.id !== UNIDENTIFIED_SPEAKER_ID)) {
        return '>>'
    }

    if (author === undefined || author.id === UNIDENTIFIED_SPEAKER_ID) {
        return 'Unidentified speaker'
    }

    return author.name
}
